/**
 * @generated SignedSource<<8ec58ee9f1ba11434231127abe2dc935>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Session__PasswordResetPayload",
    "kind": "LinkedField",
    "name": "passwordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordResetMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordResetMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "877750597e294b831b776dbd6a328821",
    "id": null,
    "metadata": {},
    "name": "PasswordResetMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordResetMutation(\n  $input: Session__PasswordResetInput!\n) {\n  passwordReset(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

node.hash = "8de484b55692a476aebf09282f537db6";

module.exports = node;
